import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=06ac226a&scoped=true"
import script from "./wxlogin.vue?vue&type=script&lang=js"
export * from "./wxlogin.vue?vue&type=script&lang=js"
import style0 from "./wxlogin.vue?vue&type=style&index=0&id=06ac226a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac226a",
  null
  
)

export default component.exports